<div class="flex justify-center px-4 py-12">
  <div class="w-full max-w-4xl">
    <article
      class="bg-white shadow-md rounded-md border-t-red-600 dark:border-t-yellow-200 border-t-4 overflow-hidden"
    >
      <div class="px-8 py-10 md:px-12">
        <p
          class="mb-3 text-sm font-semibold uppercase tracking-wide text-blue-700"
        >
          Community-powered learning
        </p>
        <h1 class="mb-6 text-primary text-4xl font-bangers tracking-wide">
          About Study Heroes
        </h1>

        <p class="mb-5 text-lg leading-8">
          Study Heroes helps students, teachers and creators find, build and
          share learning resources that are easier to access, easier to
          understand and more useful in local classrooms.
        </p>

        <p class="mb-8 leading-7">
          We focus on practical education support: free books, videos,
          activities, interactive materials and curated collections that can
          help a learner get unstuck or help a teacher prepare faster. The
          platform is shaped by the people who use it, so resources can grow
          around real curriculum needs, real languages and real communities.
        </p>

        <section class="mb-8">
          <h2 class="mb-3 text-2xl font-bold font-bangers tracking-wide">
            Our Mission
          </h2>
          <p class="leading-7">
            Our mission is to make quality learning support more available to
            every learner, especially where language, cost or access gets in the
            way. We believe education works better when learners can connect new
            ideas to the language and context they already know.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="mb-3 text-2xl font-bold font-bangers tracking-wide">
            How The Community Helps
          </h2>
          <div class="grid gap-4 md:grid-cols-3">
            <div class="border border-black/10 bg-white/80 p-4">
              <h3 class="mb-2 font-bold">Share</h3>
              <p class="text-sm leading-6">
                Help learners and teachers discover resources that already exist
                on Study Heroes.
              </p>
            </div>
            <div class="border border-black/10 bg-white/80 p-4">
              <h3 class="mb-2 font-bold">Create</h3>
              <p class="text-sm leading-6">
                Add books, videos, activities and explanations that make hard
                topics easier to understand.
              </p>
            </div>
            <div class="border border-black/10 bg-white/80 p-4">
              <h3 class="mb-2 font-bold">Localise</h3>
              <p class="text-sm leading-6">
                Translate, review and improve materials so learners can study in
                language that feels closer to home.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 class="mb-3 text-2xl font-bold font-bangers tracking-wide">
            What We Are Building Toward
          </h2>
          <p class="leading-7">
            Study Heroes is building a shared education library where useful
            resources can be found quickly, improved over time and connected to
            the books, subjects and classroom moments where learners need them
            most.
          </p>
        </section>
      </div>
    </article>

    <p class="mt-6 text-center text-secondary text-xs tracking-widest">
      &copy;2026 Study Heroes. All rights reserved.
    </p>
  </div>
</div>
